import React, { useState } from "react";
import axios from "axios";
import { Modal, Button, Spinner, Tooltip, OverlayTrigger } from "react-bootstrap";
import { CONFIG } from "../utils/config";

const StatusChecker = ({ addLog, notify }) => {
  const [showModal, setShowModal] = useState(false);
  const [statusData, setStatusData] = useState(null);
  const [checkType, setCheckType] = useState("");
  const [loading, setLoading] = useState(false);

  const check = async (type) => {
    setLoading(true);
    setCheckType(type);
    const ep = type === 'Token' ? 'token-status' : 'balance';
    
    try {
      const res = await axios[type === 'Token' ? 'post' : 'get'](`${CONFIG.API_BASE}/${ep}`);
      addLog(`${type} Check: Success`, "SUCCESS");
      setStatusData(res.data);
      setShowModal(true);
    } catch (e) {
      addLog(`${type} Check Failed: ${e.message}`, "ERROR");
      notify(`${type} Check Failed: ${e.message}`, "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="btn-group">
        <OverlayTrigger placement="bottom" overlay={<Tooltip>Check Token Validity</Tooltip>}>
          <Button variant="outline-light" size="sm" onClick={() => check('Token')} disabled={loading}>
            {loading && checkType === 'Token' ? <Spinner size="sm" animation="border" /> : "Token"}
          </Button>
        </OverlayTrigger>
        <OverlayTrigger placement="bottom" overlay={<Tooltip>Check SMS Balance</Tooltip>}>
          <Button variant="outline-light" size="sm" onClick={() => check('Balance')} disabled={loading}>
            {loading && checkType === 'Balance' ? <Spinner size="sm" animation="border" /> : "Balance"}
          </Button>
        </OverlayTrigger>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="sm">
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="h6 fw-bold">
            <i className="bi bi-info-circle-fill text-primary me-2"></i>{checkType} Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-light p-3 rounded border font-monospace small" style={{maxHeight: '300px', overflow: 'auto'}}>
             {statusData ? (
               typeof statusData === 'object' ? 
                 <pre className="m-0" style={{whiteSpace: 'pre-wrap'}}>{JSON.stringify(statusData, null, 2)}</pre> : 
                 <div className="fw-bold text-center fs-5 text-success">{statusData}</div>
             ) : (
                 <div className="text-muted text-center">No Data Received</div>
             )}
          </div>
        </Modal.Body>
        <Modal.Footer className="py-1">
            <Button size="sm" variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StatusChecker;